<template>
  <div class="p-list-box">
    <div class="p-manage-tool">
      <div
        class="p-list-search"
      >
        <a-input
          v-model="searchVal"
          style="width: 208px;"
          :placeholder="truenameTit"
          @keyup="searchMethod"
        />
        <i
          class="icon iconfont iconicon-test45"
          @click="searchMethod"
        />
      </div>
    </div>
    <div class="p-list">
      <template v-if="arr2.length">
        <ul
          class="scroll_bar_beautify_ff origin-list-ul"
        >
          <li
            v-for="(item) in arr2"
            :key="item.key"
            :class="{active: item.active }"
            @click="clickHandle($event,item)"
          >
            <div class="p-item-tit">
              <h2>
                {{ item.name }}
              </h2>
              <p
                v-if="item.label"
                class="part-team-name"> {{ item.label ? `[${item.label}]`: '' }}</p>
            </div>
          </li>
        </ul>
      </template>
      <template v-else-if="!arr2.length && noresult">
        <div class="search-no-result">
          {{ $t('message["1553"]') }}
        </div>
      </template>
      <template v-else-if="!arr2.length && !noresult">
        <div
          v-if="treeList.length"
          class="tree-p-box">
          <a-tree
            v-if="Object.keys(treeDefault).length"
            class="tree-content"
            :tree-data="treeList"
            :default-expanded-keys="[treeDefault.key]"
            :default-selected-keys="[treeDefault.key]"
            @select="onSelect"
          />
        </div>
        <div v-else>
          <a-spin tip="loading" />
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  components: {

  },
  data () {
    return {
      searchVal: '',
      arr2: [],
      key: 0,
      noresult: false
    }
  },
  computed: {
    ...mapState('organization/person', ['datas', 'cId', 'isAdmin', 'datasReady']),
    ...mapGetters('organization/person', ['selectId', 'treeList', 'treeDefault']),
    truenameTit () {
      return this.$t('message["665"]')
    }
  },
  async mounted () {
  },
  methods: {
    ...mapActions('organization/person', ['fetchItemInfoDatas', 'fetchCurrentDatas']),
    ...mapMutations('organization/person', ['setItemData']),
    async clickHandle (event, item) {
      this.arr2.forEach(item2 => {
        item2.active = false
      })
      item.active = true
      await this.getItemDetail(item.userid)
    },
    async searchMethod () {
      this.arr2 = []
      let { key, treeDefault, searchVal } = this
      const keyword = searchVal.trim()
      if (!key) {
        key = treeDefault.sys_userid
      }
      if (keyword) {
        this.searchdeep(this.treeList, this.arr2, keyword, null)
        if (this.arr2.length) {
          this.arr2[0].active = true
          await this.getItemDetail(this.arr2[0].userid)
        } else {
          this.noresult = true
          this.setItemData({})
        }
      } else {
        this.noresult = false
        await this.getItemDetail(key)
      }
    },
    async onSelect (key) {
      if (key) {
        const arr = key[0].split('|')
        const arr2 = arr.find(item => item.indexOf('sys_userid') > -1).split('-')
        // this.key = arr2[1]
        await this.getItemDetail(arr2[1])
      }
    },
    searchdeep (arr, arr2, keyword, parentName) {
      arr.forEach(item => {
        if (item.sys_userid && (item.title.indexOf(keyword) > -1)) {
          item['label'] = parentName ? `${parentName}` : ''
          arr2.push(
            {
              label: item['label'],
              userid: item.sys_userid,
              name: item.title,
              key: item.key,
              active: false
            }
          )
        } else {
          item['label'] = parentName ? `${parentName}|${item.name}` : `${item.name}`
          if (item.children && item.children.length) {
            this.searchdeep(item.children, arr2, keyword, item['label'])
          }
        }
      })
    },
    async getItemDetail (userid) {
      const chain = await this.fetchItemInfoDatas({ cid: this.cId, userid: userid })
      chain.fetch()
    }
  }
}
</script>

<style lang="scss" scoped>
.p-list-box::v-deep {
  width: 238px;
  float: left;
  min-height: 500px;
  // border-right: 1px solid #ebebeb;

  .p-manage-tool {
    padding: 16px;
    text-align: center;

    .p-list-search {
      position: relative;
      width: 208px;

      .icon {
        font-size: 14px;
        color: #ccc;
        position: absolute;
        right: 10px;
        top: 7px;
      }
    }
  }

  .p-list-search .el-input__inner {
    width: 152px;
    top: 9px;
  }

  .p-list {
    border-top: 1px solid #ebebeb;
    padding: 8px 0 24px 0;
    .search-no-result {
      text-align: center;
      padding: 16px;
    }
    .origin-list-ul {
      max-height: 450px;
      overflow-y: auto;
       li {
      padding: 8px 16px;
      list-style: none;

      .p-item-tit {
        position: relative;

        h2 {
          display: inline-block;
          line-height: 24px;
          font-size: 14px;
        }
        .part-team-name {
          font-size: 12px;
          line-height: 16px;
          height: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color:#666;
        }

        .p-role {
          height: 20px;
          line-height: 20px;
          padding: 0 6px;
          color: #fff;
          position: absolute;
          right: 0;
          background: #a57ec8;
          font-size: 12px;
          border-radius: 4px;
        }
      }

      // p {
      //   font-size: 12px;
      //   color: #b3b3b3;
      //   line-height: 16px;
      //   padding-top: 6px;
      // }
    }

    li:hover,
    li.active {
      background: #f5f5f5;

      h2 {
        font-weight: bold;
        color: #5077aa;
      }
    }
    }
  }
  .tree-p-box {
    max-height: 450px;
    overflow-y: auto;
    padding: 0 16px 16px 24px;
    .ant-tree li{
      padding: 0;
      overflow: hidden;
    }
    .ant-tree li span.ant-tree-switcher, .ant-tree li span.ant-tree-iconEle {
      width: 12px;
      color: #959595;
      height: 40px;
      line-height: 40px;
    }
    .ant-tree li .ant-tree-node-content-wrapper,li.ant-tree-treenode-disabled > span:not(.ant-tree-switcher), li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper, li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper span {
      color: #666;
      padding: 0;
    }
    .ant-tree li .ant-tree-node-content-wrapper{
      width: 100%;
      height: 40px;
      line-height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: 4px;
    }
    .ant-tree-switcher-noop {
      display: none;
    }
    .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected,.ant-tree li:not(.ant-tree-treenode-disabled) .ant-tree-node-content-wrapper:hover{
      background: #F4F7F9;
    }
    .ant-tree li ul{
      padding-left: 8px;
    }
  }
}
</style>
